/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isBlank, isEmpty, isNone } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import hydrateAndEncodeForPreview from 'cio/utils/in-app/preview';
import { InAppPreview } from 'cio/utils/previews';
import { Editor } from 'cio/services/editor';

interface PreviewArgs {
  preview?: InAppPreview;
  forceDisplay: boolean;
}

export default class Preview extends Component<PreviewArgs> {
  @tracked isLoading = true;

  get isVisualEditorMessage() {
    return this.args.preview?.editor === Editor.VISUAL;
  }

  get visualEditorBody() {
    return this.args.preview?.body_json.properties?.gist?.messageHtml ?? '';
  }

  get encodedPreviewPayload() {
    let { preview } = this.args;
    if (this.hasNoMessage) {
      return;
    }
    return hydrateAndEncodeForPreview(preview?.body_json ?? {});
  }

  get forceDisplay() {
    let { forceDisplay } = this.args;
    return forceDisplay ?? false;
  }

  get inAppPreviewUrl() {
    let payload = this.encodedPreviewPayload;
    if (isNone(payload)) {
      return;
    }
    return `https://renderer.gist.build/2.0/index.html?options=${payload}`;
  }

  get hasNoMessage() {
    let { preview } = this.args;
    return preview?.editor === Editor.VISUAL ? isBlank(this.visualEditorBody) : isBlank(preview?.body_json?.messageId);
  }

  get hasPreviewError() {
    return !isEmpty(this.errors);
  }

  get noPreviewDisplay() {
    return !this.forceDisplay && (this.hasNoMessage || this.hasPreviewError);
  }

  get errors() {
    let { preview } = this.args;
    return preview?.errors?.body_json ?? [];
  }

  get firstError() {
    return this.errors[0] ?? '';
  }

  @action
  startLoadingPreview() {
    this.isLoading = true;
  }

  @action didLoadPreview() {
    this.isLoading = false;
  }
}
